import React, { FunctionComponent } from 'react';
import styled from 'styled-components';
import Skeleton from '@empiriecom/module-components/Skeleton';

const RatingsHeadlineSkeleton = styled(Skeleton)`
  margin: 1rem 0;
`;

const RatingGridSkeleton = styled.div`
  display: flex;
  width: 100%;
  flex-flow: row nowrap;
  background-color: #f4f4f4;
  @media only screen and (max-width: 500px) {
    flex-flow: row wrap;
  }
`;

const RatingSummaryWrapperSkeleton = styled.div`
  width: 40%;
  margin: 1.5rem;
  @media only screen and (max-width: 500px) {
    width: 100%;
    margin: 0.75rem;
  }
`;

const NewRatingSkeleton = styled(Skeleton)`
  margin-top: 0.75rem;
`;

const RatingCardsSkeleton = styled.div`
  width: 60%;
  @media only screen and (max-width: 500px) {
    width: 100%;
  }
`;

const RatingCardSkeleton = styled(Skeleton)`
  margin: 1.5rem;
  @media only screen and (max-width: 500px) {
    margin: 0.75rem;
  }
`;

export const RatingSummarySkeleton: FunctionComponent = (): JSX.Element => (
  <>
    <RatingsHeadlineSkeleton height="3rem" />
    <RatingGridSkeleton>
      <RatingSummaryWrapperSkeleton>
        <Skeleton height="12rem" />
        <NewRatingSkeleton height="5rem" />
      </RatingSummaryWrapperSkeleton>
      <RatingCardsSkeleton>
        <RatingCardSkeleton height="6rem" />
        <RatingCardSkeleton height="5rem" />
        <RatingCardSkeleton height="6rem" />
        <RatingCardSkeleton height="6rem" />
      </RatingCardsSkeleton>
    </RatingGridSkeleton>
  </>
);

export default RatingSummarySkeleton;
